export const FETCH_APPAREL_ITEM = 'APPAREL_EDITOR/FETCH_APPAREL_ITEM';
export const FETCH_APPAREL_ITEM_SUCCESS = 'APPAREL_EDITOR/FETCH_APPAREL_ITEM_SUCCESS';
export const FETCH_APPAREL_ITEM_ERROR = 'APPAREL_EDITOR/FETCH_APPAREL_ITEM_ERROR';
export const FETCH_DEPARTMENT = 'APPAREL_EDITOR/FETCH_DEPARTMENT';
export const FETCH_DEPARTMENT_SUCCESS = 'APPAREL_EDITOR/FETCH_DEPARTMENT_SUCCESS';
export const FETCH_DEPARTMENT_ERROR = 'APPAREL_EDITOR/FETCH_DEPARTMENT_ERROR';
export const ADD_TO_CART = 'APPAREL_EDITOR/ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = 'APPAREL_EDITOR/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'APPAREL_EDITOR/ADD_TO_CART_ERROR';
export const CHECK_SHIRTS = 'APPAREL_EDITOR/CHECK_SHIRTS';
export const CHECK_SHIRTS_SUCCESS = 'APPAREL_EDITOR/CHECK_SHIRTS_SUCCESS';
export const CHECK_SHIRTS_ERROR = 'APPAREL_EDITOR/CHECK_SHIRTS_ERROR';
export const ADD_FAVORITE = 'APPAREL_EDITOR/ADD_FAVORITE';
export const ADD_FAVORITE_SUCCESS = 'APPAREL_EDITOR/ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'APPAREL_EDITOR/ADD_FAVORITE_ERROR';
export const CHECK_FAVORITE = 'APPAREL_EDITOR/CHECK_FAVORITE';
export const CHECK_FAVORITE_SUCCESS = 'APPAREL_EDITOR/CHECK_FAVORITE_SUCCESS';
export const CHECK_FAVORITE_ERROR = 'APPAREL_EDITOR/CHECK_FAVORITE_ERROR';
export const SET_TEMPLATE_CODE = 'APPAREL_EDITOR/SET_TEMPLATE_CODE';
export const SET_QUANTITY = 'APPAREL_EDITOR/SET_QUANTITY';
export const SET_SIZE = 'APPAREL_EDITOR/SET_SIZE';
export const SET_LOGO = 'APPAREL_EDITOR/SET_LOGO';
export const RESET_STATE = 'APPAREL_EDITOR/RESET_STATE';
export const ADD_PERSON = 'APPAREL_EDITOR/ADD_PERSON';
export const REMOVE_PERSON = 'APPAREL_EDITOR/REMOVE_PERSON';
export const SET_PERSON_FIELD = 'APPAREL_EDITOR/SET_PERSON_FIELD';
export const SET_PERSON_QUANTITY = 'APPAREL_EDITOR/SET_PERSON_QUANTITY';
export const INIT_PERSONS = 'APPAREL_EDITOR/INIT_PERSONS';
export const SET_MANAGER_CLINIC_NAME = 'APPAREL_EDITOR/SET_MANAGER_CLINIC_NAME';
export const SET_MANAGER_NAME = 'APPAREL_EDITOR/SET_MANAGER_NAME';
export const SET_MANAGER_EMAIL = 'APPAREL_EDITOR/SET_MANAGER_EMAIL';
export const SET_MANAGER_ADDRESS = 'APPAREL_EDITOR/SET_MANAGER_ADDRESS';
export const SET_MANAGER_CITY = 'APPAREL_EDITOR/SET_MANAGER_CITY';
export const SET_MANAGER_STATE = 'APPAREL_EDITOR/SET_MANAGER_STATE';
export const SET_MANAGER_ZIP = 'APPAREL_EDITOR/SET_MANAGER_ZIP';
export const SET_MANAGER_PHONE = 'APPAREL_EDITOR/SET_MANAGER_PHONE';
export const SET_PERSONALIZATION_ENABLED = 'APPAREL_EDITOR/SET_PERSONALIZATION_ENABLED';
export const SET_APPAREL_ITEM = 'APPAREL_EDITOR/SET_APPAREL_ITEM';
export const SET_DEPARTMENT = 'APPAREL_EDITOR/SET_DEPARTMENT';
export const SET_ACTION = 'APPAREL_EDITOR/SET_ACTION';
export const SET_FIELD = 'APPAREL_EDITOR/SET_FIELD';
export const ADD_FILE = 'APPAREL_EDITOR/ADD_FILE';
export const REMOVE_FILE = 'APPAREL_EDITOR/REMOVE_FILE';
export const CLEAR_FILES = 'APPAREL_EDITOR/CLEAR_FILES';